import { pdfjs, Document, Page } from 'react-pdf';
import pdfjsWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.js?url';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl;

export { pdfjs, Document, Page };
